import React, { useMemo, useRef, useState } from 'react';
import { ModalContext } from './ModalContext';

type Props = {
  children: React.ReactNode;
};

export function ModalProvider({ children }: Props) {
  const [currentModal, setCurrentModal] = useState<React.ReactNode | null>(null);
  const modalContainerRef = useRef<HTMLDivElement>(null);
  const contextValue = useMemo(
    () => ({
      currentModal,
      setCurrentModal,
      modalContainerRef
    }),
    [currentModal, modalContainerRef]
  );
  return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>;
}
